import React, { useState } from "react";
import { Checkbox } from "@my-scoot/component-library-legacy";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { useDeleteColumnModal } from "./utils/useDeleteColumnModal";
import classnames from "classnames";
import { useDeleteCustomColumn } from "../CustomColumn/apis/deleteCustomColumn";
import { useCrmStore } from "features/Crm/store/useCrmStore";
import { useEditCustomColumnModal } from "../EditCustomColumnModal/utils/useEditCustomColumnModal";

export const DeleteColumnModal = ({ sectionName }) => {
  const [checked, setIschecked] = useState(false);
  const deleteCustomColumn = useDeleteCustomColumn({ sectionName });
  const { isDeleteCustomColumnModalOpen, closeDeleteCustomColumnModal } =
    useDeleteColumnModal();
  const { closeEditCustomColumnModal } = useEditCustomColumnModal();
  const activeCustomColumn = useCrmStore((state) => state.activeCustomColumn);
  const setActiveCustomColumn = useCrmStore(
    (state) => state.setActiveCustomColumn
  );

  const handleDelete = () => {
    deleteCustomColumn.mutate(
      { custom_column_uuid: activeCustomColumn.uuid },
      {
        onSuccess: () => {
          closeDeleteCustomColumnModal();
          closeEditCustomColumnModal();
          setActiveCustomColumn(null);
        },
      }
    );
  };

  return (
    <ExlyModal
      title="Are you sure?"
      primaryBtnText="Delete"
      onPrimaryBtnClick={handleDelete}
      secondaryBtnText="Close"
      onSecondaryBtnClick={closeDeleteCustomColumnModal}
      secondaryBtnProps={{
        buttonWrapperClassName: "tw-flex-1",
        fullWidth: true,
      }}
      primaryBtnProps={{
        buttonWrapperClassName: classnames(
          "tw-flex-1",
          !checked && "!tw-cursor-not-allowed"
        ),
        loading: deleteCustomColumn.isLoading,
        disabled: !checked || deleteCustomColumn.isLoading,
      }}
      open={isDeleteCustomColumnModalOpen}
      onClose={closeDeleteCustomColumnModal}
      padded={false}
      modal_props={{
        modalPaperClassName: "tw-w-[428px]",
        secondaryBtnClassName:
          "tw-min-w-unset !tw-border-[1px] !tw-border-solid !tw-border-[#272522] !tw-bg-white !tw-text-[#272522] hover:tw-bg-transparent",
        primaryBtnClassName: classnames(
          "!tw-bg-[#bf2600]",
          !checked &&
            "tw-pointer-events-none tw-cursor-not-allowed tw-opacity-50"
        ),
        footerClassName: "!tw-justify-between !tw-py-8 !tw-px-4",
        primaryBtnFullWidth: true,
      }}
      mobile_modal_props={{
        secondaryAction: {
          label: "Close",
          onClick: closeDeleteCustomColumnModal,
          className:
            "tw-min-w-unset !tw-border-[1px] !tw-border-solid !tw-border-[#272522] !tw-bg-white !tw-text-[#272522] hover:tw-bg-transparent",
        },
      }}
    >
      <div className="tw-flex tw-justify-start tw-flex-col tw-py-[14px] tw-px-[18px] tw-gap-[16px]">
        <div className="tw-text-[#272522] tw-text-[14px] tw-font-normal tw-leading-[19px] tw-tracking-[0.28px]">
          This column is used in customer flows. Deleting it will remove the
          field from all locations and all related data will be lost.
        </div>
        <div className="tw-text-[#272522] tw-text-[14px] tw-font-medium tw-tracking-[0.28px] tw-flex tw-items-center tw-gap-[12px]">
          <Checkbox
            onChange={() => setIschecked((prev) => !prev)}
            checked={checked}
            size="large"
          />
          I have read and agree to proceed with deletion.
        </div>
      </div>
    </ExlyModal>
  );
};
